module.exports = __webpack_public_path__ + "static/media/N.55da09b1.svg";